import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog.service';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [ConfirmationDialogComponent],
  providers: [ConfirmationDialogService],
})
export class ConfirmationDialogModule {}
